<template>
    <div class="menu-div">
        <div v-for="(item, index) in DataList" :key="index" class="kuai-div">
            <div v-if="item.children.length > 0" class="kuai-div">
                <div class="kuaiji-div kuaiji-div-tr" @click="xiangClick(item)" :id="'kuaiji_' + item.ID" :style="paddingLeftStyle">
                    <div class="icon-div" v-html="item.icon"></div>
                    <div class="xiang-div">{{ item.name }}</div>
                    <div class="jiantou-div-up" v-if="item.isFold">︿</div>
                    <div class="jiantou-div-down" v-else>﹀</div>
                </div>
                <div class="children-div" :id="item.ID">
                    <MultiLevelNavMenu :DataList="item.children" 
                    :deep="deep + 1" :FoverDataList="FoverDataList" 
                    style="padding: 0px;width: 100%;" @item-click="$emit('item-click', $event)"></MultiLevelNavMenu>
                </div>
            </div>
            <div v-else class="kuaiji-div kuaiji-div-tr" @click="xiangClick(item)" :id="'kuaiji_' + item.ID" :style="paddingLeftStyle">
                <div class="icon-div" v-html="item.icon" id="12"></div>
                <div class="xiang-div">{{ item.name }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MultiLevelNavMenu',
    props: {
        DataList: {
            type: Array,
            required: true
        },
        deep: {
            type: Number,
            default: 1,
            required: false
        },
        FoverDataList: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            dedeep: 5,
            FoverDataLists: [],
            BLOCKHEIGHT: 70,
            zIndexNumber: 20
        };
    },
    computed: {
        paddingLeftStyle() {
            const paddingValue = this.deep * 10; // 每层缩进20px
            return {
                paddingLeft: `${paddingValue}px`,
                zIndex: `${this.zIndexNumber - this.deep}`
            };
        }
    },
    methods: {
        xiangClick(item) {
            // console.log("组件被点击",item);
            if (Object.keys(item).includes("isFold")) { // 检查 'isFold' 是否存在
                if (item.isFold === true) {
                    this.foldDomClose(item);
                    item.isFold = false;
                    
                } else if (item.isFold === false) {
                    this.foldDomOpen(item);
                    item.isFold = true;
                }
            }else{
                this.styleAll(this.FoverDataLists);
                document.getElementById("kuaiji_" + item.ID).classList.add('kuaiji-div-clicks');
                
            }
            this.$emit('item-click', item); // 触发一个名为 'item-click' 的事件，并传递当前点击的 item。
            
        },
        /**
         * 将传入数据进行添加ID属性
         * @param { Array } List 
         * @param { String } types ["init", "cir"]
         * @param { String } pID 
         */
        dataClean(List, types, pID) {
            if (types == "init"){
                if (this.judgmentList(List)){
                    return;
                }
            }
            if (!["init", "cir"].includes(types)){
                this.$messageX.xiaoxiti("f", "系统运行出现错误！tip【types错误】");
                return;
            }
            for (var item of List){
                item["ID"] = this.$messageX.generateGUID();
                item["parentID"] = pID;
                if (item.children.length > 0){
                    item["isFold"] = false;
                    this.dataClean(item.children, "cir", item["ID"]);
                }
            }
        },
        /**
         * 判断传入数据是否需要进行清理（有无GUID属性）
         * @param { Array } List 
         * @return { Boolean } true or false
         * @author ZhiYun<1920192401@qq.com>
         * @example judgmentList(List)
         */
        judgmentList(List) {
            for (var item of List){
                if (!item.ID){
                    return false;
                }
                if (item.children.length > 0){
                    this.judgmentList(item.children);
                }
            }
            return true;
        },
        foldDomOpen(item) {
            if (item.children.length > 0){
                var ls_dom = document.getElementById(item.ID);
                if (item.parentID != ""){
                    var ls_dom_parent = document.getElementById(item.parentID);
                    ls_dom.style.height = item.children.length * this.BLOCKHEIGHT + "px";
                    ls_dom.style.opacity = 1;
                    ls_dom_parent.style.height = Number(ls_dom_parent.style.height.split("px")[0]) + item.children.length * this.BLOCKHEIGHT + "px";
                }else{
                    ls_dom.style.height = item.children.length * this.BLOCKHEIGHT + "px";
                    ls_dom.style.opacity = 1;
                }
            }
        },
        foldDomClose(item) {
            if (item.children.length > 0){
                let ls_dom = document.getElementById(item.ID);
                if (item.parentID != ""){
                    let ls_dom_parent = document.getElementById(item.parentID);
                    ls_dom.style.height = "0px";
                    ls_dom.style.opacity = 0;
                    ls_dom_parent.style.height = Number(ls_dom_parent.style.height.split("px")[0]) - item.children.length * this.BLOCKHEIGHT + "px";
                    this.closeAll(item.children);
                }else{
                    ls_dom.style.height = "0px";
                    ls_dom.style.opacity = 0;
                    this.closeAll(item.children);
                }
            }
        },
        closeAll(List) {
            for (var item of List){
                if (Object.keys(item).includes("isFold")){
                    if (item.isFold){
                        item.isFold = false;
                        let ls = document.getElementById(item.ID);
                        ls.style.height = "0px";
                        ls.style.opacity = 0;
                    }
                    if (item.children.length > 0){
                        this.closeAll(item.children);
                    }
                }
            }
        },
        styleAll(List) {
            for (var item of List){
                document.getElementById("kuaiji_" + item.ID).classList.remove('kuaiji-div-clicks');
                if (item.children.length > 0){
                    this.styleAll(item.children);
                }
            }
        }
    },
    watch: {
        FoverDataList: {
            handler(newVal) {
                this.FoverDataLists = newVal;
            },
            immediate: true // 表示在初始化时也执行一次 handler
        }
    },
    mounted() {
        this.dataClean(this.FoverDataLists, "init", "");
    }
};
</script>

<style scoped>
.menu-div {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    /* width: calc(100% - 20px); */
    overflow: auto;
    /* padding-right: 10px;
    padding-left: 10px;
    padding-top: 5px;
    padding-bottom: 10px; */
}

.xiang-div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    padding-left: 5px;
    width: 80px;
    height: 70px;
    font-weight: 600;
}

.kuai-div {
    width: 100%;
    overflow: hidden;
}

.icon-div {
    width: 20px;
    margin-right: 5px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
}

.kuaiji-div {
    width: calc(100% - 20px);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    background-color: rgba(210, 210, 210, 0);
    margin: 10px;
    height: 50px;
    box-sizing: border-box;
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    transition: all 0.5s ease;
}

.kuaiji-div-tr:hover {
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  background-color: #4a76da;
  color: white;
}

.kuaiji-div-clicks {
  background-color: #4a76da;
  color: white;
}

.children-div {
    background-color: rgba(210, 210, 210, 0.45);
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    transition: all 0.5s ease;
    height: 0px;
    opacity: 0;
    border-radius: 10px;
}

.jiantou-div-up {
    width: 20px;
    position: absolute;
    right: 5px;
    top: 9px;
}

.jiantou-div-down {
    width: 20px;
    position: absolute;
    right: 5px;
    top: 17px;
}

</style>